<template>
  <div class="default-header" ref="defaultHeader">
    <div class="header-left">
      <!-- <div class="header-item" @click="handleMenu">
        <a-icon type="menu-fold" class="menu-fold" />
      </div> -->

      <!-- 首页 -->
      <div class="header-item ellipsis title" @click="appIndex">
        <span v-if="!detailName">
          {{
            userInfo.campus_name
              ? userInfo.campus_name
              : userInfo.company_name
              ? userInfo.company_name
              : systemName
          }}
        </span>
        &nbsp;<span v-if="detailName">{{ detailName }}</span>
      </div>
    </div>

    <div class="header-center"></div>
    <div class="header-right">
      <!-- 切换语言 -->
      <a-dropdown>
        <div class="header-item">Language</div>
        <a-menu
          slot="overlay"
          class="dropdown-wrap dropdown-language"
          @click="changeLanguage"
        >
          <a-menu-item key="zh_CN" :disabled="$i18n.locale === 'zh_CN'">
            中文
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="en" :disabled="$i18n.locale === 'en'">
            English
          </a-menu-item>
        </a-menu>
      </a-dropdown>

      <!-- 登陆信息 -->
      <a-dropdown>
        <div class="header-item user-info">
          <img
            class="avatar"
            :src="userInfo.headPortrait ? userInfo.headPortrait : avatar"
          />
        </div>

        <a-menu slot="overlay" class="admin-wrap">
          <a-menu-item key="admin" disabled>
            <div class="admin">
              <a-upload
                name="avatar"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                accept="image/*"
                :beforeUpload="beforeUpload"
                :action="null"
              >
                <img
                  :src="userInfo.headPortrait ? userInfo.headPortrait : avatar"
                  class="avatar"
                />
                <div class="example" v-if="uploadHeader">
                  <a-spin />
                </div>
              </a-upload>
              <div class="name">{{ userInfo.name }}</div>
              <div style="margin-top: -10px">{{ userInfo.account }}</div>
            </div>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="password" @click="confirmChangePassword">
            {{ $t('user.changePassword') }}
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="logout" @click="logout">
            {{ $t('user.signOut') }}
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>

    <!-- 菜单 -->
    <a-drawer
      placement="left"
      width="400"
      :closable="false"
      :visible="drawerVisible"
      @close="close"
    >
      <div @click="handleMenu" class="menu-wrap">
        <a-icon type="menu-unfold" class="menu-fold" />
      </div>

      <a-card title="Card title" :bordered="false">
        <p>Card content</p>
        <p>Card content</p>
        <p>Card content</p>
      </a-card>
    </a-drawer>

    <!-- 添加编辑 -->
    <a-modal
      :title="$t('user.changePassword')"
      v-model="modalVisible"
      :confirmLoading="modalLoading"
      :afterClose="afterClose"
      @ok="ok"
    >
      <a-form :form="form" layout="vertical" class="password-form">
        <a-form-item
          :label="$t('user.password')"
          :colon="false"
          :extra="
            `${
              form.getFieldValue('password')
                ? form.getFieldValue('password').length
                : '0'
            }/24`
          "
        >
          <a-input
            type="password"
            maxLength="24"
            :placeholder="$t('user.password')"
            v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('user.password')
                    })
                  },
                  {
                    validator: validateConfirmPassword
                  }
                ]
              }
            ]"
          >
          </a-input>
        </a-form-item>

        <a-form-item
          :label="$t('user.confirmPassword')"
          :colon="false"
          :extra="
            `${
              form.getFieldValue('confirmPassword')
                ? form.getFieldValue('confirmPassword').length
                : '0'
            }/24`
          "
        >
          <a-input
            type="password"
            maxLength="24"
            :placeholder="$t('user.confirmPassword')"
            v-decorator="[
              'confirmPassword',
              {
                rules: [
                  { required: true, message: $t('user.confirmPasswordTip') },
                  {
                    validator: comparePassword
                  }
                ]
              }
            ]"
          >
          </a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import utils from '../../utils/index.js'
export default {
  computed: {
    ...mapGetters(['userInfo', 'userId', 'indexRouter', 'systemName']),
    detailName() {
      return this.$store.state.routerManage.detailName
    }
  },

  data() {
    return {
      avatar: require('../../assets/img/avatar.png'),
      avatarUrl: null,
      drawerVisible: false,
      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      uploadHeader: false
      // GetdetailName: this.$store.state.routerManage.detailName
    }
  },

  methods: {
    // 菜单
    handleMenu() {
      this.drawerVisible = !this.drawerVisible
    },

    // 首页
    appIndex() {
      this.$router.push({ name: this.indexRouter })
    },
    // 切换语言
    changeLanguage(v) {
      if (v.key !== this.$i18n.locale) {
        this.$confirm({
          title: this.$t('public.switchLanguage'),
          content: '',
          onOk: () => {
            this.$store.commit('SET_LOCALELANGUAGE', v.key)
          },
          onCancel() {}
        })
      }
    },

    close() {
      this.drawerVisible = false
    },

    // 修改密码
    validateConfirmPassword(rule, value, callback) {
      const confirmPassword = this.form.getFieldValue('confirmPassword')
      if (value && confirmPassword) {
        this.form.validateFields(['confirmPassword'], { force: true }, () => {})
      }
      callback()
    },

    comparePassword(rule, value, callback) {
      const password = this.form.getFieldValue('password')
      if (value && password && value !== password) {
        callback(this.$t('user.passwordsInconsistent'))
      } else {
        callback()
      }
    },

    confirmChangePassword() {
      this.modalVisible = true
    },

    // 提交
    ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.updatePwd(values)
        }
      })
    },

    afterClose() {
      this.form.resetFields()
      this.modalLoading = false
    },

    updatePwd(values) {
      this.modalLoading = true
      this.$http(this.$api.UPDATEPWD, {
        id: this.userId,
        password: values.password
      })
        .then(() => {
          this.modalVisible = false
          this.$message.success(this.$t('user.changePasswordSuccess'))
        })
        .catch(() => {
          this.modalLoading = false
        })
    },

    logout() {
      this.$cookie.remove('token')
      localStorage.clear()
      // 清空vuex
      window.location.reload()
    },
    //头像上传
    beforeUpload(file) {
      this.uploadHeader = true
      let currentTime = new Date().getTime()
      let filename = file.name
      filename =
        filename.split('.')[0] + currentTime + '.' + filename.split('.')[1]
      let AliyunUpload = utils.AliyunUpload(this.$config, filename, file)
      AliyunUpload.then(r => {
        let serveData = {
          userId: this.userId,
          url: r.res.requestUrls[0]
        }
        this.changeHeader(serveData, r.res.requestUrls[0])
      })
      return false //阻止upload框架自动上传
    },
    //修改头像
    changeHeader(data, url) {
      this.$http(this.$api.CHANGEHEADER, data, 'post').then(r => {
        if (r.code == 0) {
          let CSVPAUserInfo = JSON.parse(localStorage.getItem('CSVPAUserInfo'))
          CSVPAUserInfo.headPortrait = url
          localStorage.setItem('CSVPAUserInfo', JSON.stringify(CSVPAUserInfo))
          this.userInfo.headPortrait = url
          this.$store.commit('SET_USERINFO', this.userInfo)
          this.uploadHeader = false
        } else {
          this.uploadHeader = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.default-header {
  height: 100%;
  display: flex;
  justify-content: space-between;
  .header-left,
  .header-right {
    display: flex;
    /* 导航单例统一样式 */
    .message {
      background-color: #6aaae4;
      line-height: 48px;
      width: 60px;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
      &:hover {
        background-color: @headerActiveBackColor;
      }
    }
    .header-item {
      background-color: @headerBackColor;
      padding: 0 20px;
      display: flex;
      align-items: center;
      color: @headerFontColor;
      cursor: pointer;
      .item-text {
        font-size: 16px;
      }
      &:hover {
        background-color: @headerActiveBackColor;
        /* .student {
          background-image: url('../../assets/img/pageHeader/student.png');
        } */
      }
      .header-item--icon {
        width: @iconWidth;
        height: @iconHeight;
        margin-right: 12px;
        background-size: cover;
      }
      /* .student {
        background-image: url('../../assets/img/pageHeader/student_active.png');
      } */
    }
  }
  .header-left {
    .title {
      padding: 0 24px;
      font-size: 16px;
    }
  }
  .header-right {
    justify-content: flex-end;
    .user-info {
      padding: 4px 15px;
      .avatar {
        height: 40px;
        width: 40px;
        border-radius: 50%;
      }
    }
  }
  .header-center {
    flex-grow: 1;
    background-color: @themeColor;
  }
  .change-password-form {
    width: 95%;
  }
}

.menu-fold {
  font-size: 24px;
  cursor: pointer;
}
.menu-wrap {
  margin-bottom: 20px;
}

// 悬浮面板
.admin-wrap {
  padding: 0;
  width: 180px;
  text-align: center;
  .ant-dropdown-menu-item {
    line-height: 26px;
  }
  .ant-dropdown-menu-item-divider,
  .ant-dropdown-menu-submenu-title-divider {
    margin: 0;
  }
  .ant-dropdown-menu-item-disabled,
  .ant-dropdown-menu-item-disabled:hover,
  .ant-dropdown-menu-submenu-title-disabled:hover {
    cursor: default;
    color: #000;
  }
  .admin {
    padding-top: 8px;
    // wid
    // /deep/.avatar-uploader{
    //   position: relative;
    //   /deep/ .ant-upload{
    //     position: absolute;
    //     left: 50%;
    //     transform: translateX(-50%)
    //   }
    // }
    /deep/ .ant-upload {
      width: 100%;
      position: relative;

      /deep/ .example {
        width: 100%;
        height: 100%;
        text-align: center;
        background: #ffffff;
        border-radius: 4px;
        position: absolute;
        z-index: 10;
        top: 0;
        left: 0;
        /deep/ .ant-spin {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        // padding: 30px 50px;
        // padding-top: 30%;
      }
    }
  }
  .avatar {
    height: 50px;
    width: 50px;
    border-radius: 50%;
  }
  .name {
    line-height: 30px;
    padding: 0 20px;
  }
}

.password-form {
  padding: 0 10px;
}
</style>
